import React, { useEffect } from 'react'
import { useQuery } from 'react-apollo'
import styled from 'styled-components/macro'

import { Modal } from '../../components/ui'
import { UBDI_TRIBE_ID } from '../../screens/TribeDetails/_utils'
import { AllFollowersQuery } from '../../state/queries'
import { FollowersList } from './components/FollowersList'

const ModalWrap = styled.div`
  width: 600px;
  min-height: 400px;
  position: relative;
  max-height: 750px;
  height: auto;
  overflow: auto;
  padding-bottom: ${({ theme }) => theme.padding.l};
`

export const Followers = ({ onDismiss, params = {} }) => {
  const { member, currentUser } = params
  const { data: { allFollowers } = {}, loading, refetch } = useQuery(
    AllFollowersQuery,
    {
      variables: {
        targetMemberId: member.id,
        tribeId: UBDI_TRIBE_ID
      }
    }
  )

  useEffect(() => {
    refetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading) return null

  return (
    <Modal
      isOpen
      onDismiss={onDismiss}
      title={`Followers (${allFollowers.length})`}
    >
      {() => (
        <ModalWrap>
          <FollowersList data={allFollowers} currentUser={currentUser} />
        </ModalWrap>
      )}
    </Modal>
  )
}
